import axios from 'axios';
import { useEffect, useState } from 'react';
import Footer from '../component/Footer';

export default function How() {
    const [images, setImages] = useState([]);
    const [loading, setLoading] = useState(true);

    const fetchImages = async () => {
        try {
            setLoading(true);
            const response = await axios.get(`${process.env.REACT_APP_API_URL}/setting/document`, { params: { type: 'order' } });
            setImages(response?.data || []);
        } catch (error) {
            console.error(error);
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        fetchImages();
    }, []);

    const detailSteps = [
        {
            step: 1,
            title: 'Nghe Main Story',
            desc: 'Nghe câu chuyện chính nhiều lần. Lần đầu chỉ cần nghe tổng quát để nắm ý chính, không cần hiểu từng từ.',
            tips: ['Nghe ít nhất 3-5 lần vào ngày đầu tiên', 'Đọc theo transcript nếu cần', 'Tập trung vào ngữ điệu và cách phát âm'],
            icon: '📖',
            bg: 'bg-blue-50 border-blue-200'
        },
        {
            step: 2,
            title: 'Học Vocabulary',
            desc: 'Nghe bài giảng từ vựng. Giáo viên sẽ giải thích các từ mới bằng tiếng Anh đơn giản, kèm ví dụ trong ngữ cảnh.',
            tips: ['Không cố ghi nhớ, chỉ cần nghe hiểu', 'Nghe lại phần nào chưa hiểu', 'Liên tưởng từ vựng với hình ảnh'],
            icon: '📝',
            bg: 'bg-green-50 border-green-200'
        },
        {
            step: 3,
            title: 'Mini-Story (Quan trọng nhất)',
            desc: 'Nghe và TRẢ LỜI NHANH các câu hỏi. Giáo viên hỏi → bạn trả lời to → phản xạ giao tiếp được hình thành.',
            tips: ['Luôn trả lời TO tiếng', 'Trả lời ngắn gọn, không cần câu hoàn chỉnh', 'Nếu chưa hiểu câu hỏi, nghe lại', 'Đây là bài tập QUAN TRỌNG NHẤT'],
            icon: '🎯',
            bg: 'bg-red-50 border-red-200'
        },
        {
            step: 4,
            title: 'Point of View Story',
            desc: 'Nghe cùng câu chuyện nhưng ở các thì khác nhau (quá khứ, hiện tại, tương lai). Bạn sẽ tự nhiên nắm ngữ pháp.',
            tips: ['Chú ý sự thay đổi của động từ', 'Không cần học quy tắc ngữ pháp', 'Nghe nhiều lần để quen với từng thì'],
            icon: '🔄',
            bg: 'bg-purple-50 border-purple-200'
        },
        {
            step: 5,
            title: 'Commentary (Bổ sung)',
            desc: 'Nghe bài bình luận bổ sung thêm kiến thức về chủ đề, văn hóa, và cách sử dụng ngôn ngữ trong thực tế.',
            tips: ['Thư giãn và thưởng thức', 'Tìm hiểu thêm về văn hóa Anh-Mỹ', 'Ghi chú nếu có ý tưởng hay'],
            icon: '💬',
            bg: 'bg-orange-50 border-orange-200'
        },
        {
            step: 6,
            title: 'Lặp lại 7 ngày',
            desc: 'Lặp lại TẤT CẢ các bước trên trong ÍT NHẤT 7 ngày liên tục trước khi chuyển sang bài mới. Đây là bí quyết Deep Learning.',
            tips: ['Mỗi ngày nghe ít nhất 30-60 phút', 'Không vội chuyển bài mới', 'Kiên nhẫn — kết quả sẽ đến sau 2-3 tháng'],
            icon: '🔁',
            bg: 'bg-yellow-50 border-yellow-200'
        }
    ];

    return (
        <>
            <div className="min-h-screen bg-gradient-to-b from-[#eef9ff] to-white">
                {/* Hero */}
                <div className="bg-gradient-to-r from-[#1e90ff] to-[#4fc3f7] text-white py-20">
                    <div className="max-w-screen-xl mx-auto px-6 text-center">
                        <h1 className="text-4xl md:text-5xl font-extrabold mb-4">Cách Học Chi Tiết</h1>
                        <p className="text-lg text-blue-100 max-w-3xl mx-auto">Hướng dẫn từng bước để học tiếng Anh hiệu quả theo phương pháp Effortless English</p>
                    </div>
                </div>

                <div className="max-w-screen-xl mx-auto px-6 py-12">
                    {/* Image Guide */}
                    {!loading && images.length > 0 && (
                        <div className="mb-12">
                            <h2 className="text-3xl font-bold text-gray-800 mb-8 text-center">Hình ảnh hướng dẫn</h2>
                            <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
                                {images.map((img, index) => (
                                    <div key={index} className="rounded-xl overflow-hidden shadow-lg hover:shadow-xl transition-all hover:scale-[1.02]">
                                        <img src={img.url} alt={`Guide step ${index + 1}`} className="w-full h-72 object-cover" crossOrigin="anonymous" />
                                    </div>
                                ))}
                            </div>
                        </div>
                    )}

                    {/* Detailed Steps */}
                    <h2 className="text-3xl font-bold text-gray-800 mb-8 text-center">6 bước học chi tiết</h2>
                    <div className="space-y-8 mb-12">
                        {detailSteps.map((step, index) => (
                            <div key={index} className={`${step.bg} border rounded-2xl p-6 md:p-8`}>
                                <div className="flex items-start gap-4">
                                    <div className="text-4xl">{step.icon}</div>
                                    <div className="flex-1">
                                        <div className="flex items-center gap-3 mb-3">
                                            <span className="bg-white text-gray-800 rounded-full w-8 h-8 flex items-center justify-center font-bold text-sm shadow">{step.step}</span>
                                            <h3 className="text-xl font-bold text-gray-800">{step.title}</h3>
                                        </div>
                                        <p className="text-gray-700 mb-4">{step.desc}</p>
                                        <div className="bg-white bg-opacity-70 rounded-xl p-4">
                                            <p className="font-semibold text-gray-700 mb-2">💡 Mẹo:</p>
                                            <ul className="space-y-1">
                                                {step.tips.map((tip, i) => (
                                                    <li key={i} className="flex items-start gap-2 text-gray-600 text-sm">
                                                        <span className="text-green-500 mt-0.5">✓</span>
                                                        <span>{tip}</span>
                                                    </li>
                                                ))}
                                            </ul>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        ))}
                    </div>

                    {/* Schedule suggestion */}
                    <div className="bg-white rounded-2xl shadow-xl p-8 md:p-12 mb-12">
                        <h2 className="text-2xl font-bold text-gray-800 mb-6 text-center">📅 Lịch học gợi ý (1 tuần)</h2>
                        <div className="overflow-x-auto">
                            <table className="w-full text-sm">
                                <thead>
                                    <tr className="bg-blue-50">
                                        <th className="px-4 py-3 text-left font-bold text-blue-800 rounded-tl-lg">Thời gian</th>
                                        <th className="px-4 py-3 text-left font-bold text-blue-800">Hoạt động</th>
                                        <th className="px-4 py-3 text-left font-bold text-blue-800 rounded-tr-lg">Thời lượng</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr className="border-b"><td className="px-4 py-3 font-medium">Sáng</td><td className="px-4 py-3">Nghe Main Story + Vocabulary</td><td className="px-4 py-3">20 phút</td></tr>
                                    <tr className="border-b bg-gray-50"><td className="px-4 py-3 font-medium">Trưa</td><td className="px-4 py-3">Mini-Story (trả lời câu hỏi)</td><td className="px-4 py-3">20 phút</td></tr>
                                    <tr className="border-b"><td className="px-4 py-3 font-medium">Tối</td><td className="px-4 py-3">POV Story + Commentary</td><td className="px-4 py-3">20 phút</td></tr>
                                    <tr className="bg-blue-50"><td className="px-4 py-3 font-bold rounded-bl-lg">Tổng</td><td className="px-4 py-3 font-bold">Lặp lại bài này 7 ngày liên tục</td><td className="px-4 py-3 font-bold rounded-br-lg">60 phút/ngày</td></tr>
                                </tbody>
                            </table>
                        </div>
                    </div>

                    {/* CTA */}
                    <div className="bg-gradient-to-r from-green-500 to-emerald-700 rounded-2xl p-8 text-white text-center">
                        <h2 className="text-3xl font-bold mb-4">Bắt đầu học ngay!</h2>
                        <p className="text-green-100 mb-6">Chọn khóa học và áp dụng phương pháp trên để thấy sự tiến bộ rõ rệt</p>
                        <a href="/topic" className="inline-block bg-white text-green-600 font-bold px-8 py-3 rounded-full hover:bg-green-50 transition-colors shadow-lg">Chọn khóa học →</a>
                    </div>
                </div>
            </div>
            <Footer />
        </>
    );
}
